
export const convertToEuros = (denars) => Math.floor(denars/62);

export const convertToDenars = (euros) => euros*62;
